// src/locales/en/auth.js
export const auth = {
    login: "உள்நுழை",
    signup: "பதிவுசெய்",
    logout: "வெளியேறு",
    email: "மின்னஞ்சல் முகவரி",
    password: "கடவுச்சொல்",
    confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்து",
    name: "முழுப் பெயர்",
    rememberMe: "என்னை நினைவில் வைத்துக்கொள்",
    forgotPassword: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    dontHaveAccount: "கணக்கு இல்லையா?",
    alreadyHaveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
    signIn: "உள்நுழை",
    createAccount: "கணக்கை உருவாக்கு",
    continueWithGoogle: "Google உடன் தொடர",
    welcomeBack: "மீண்டும் வருக",
    signInToDashboard: "உங்கள் மின்வணிக டாஷ்போர்டில் உள்நுழையுங்கள்",
    startManaging: "இன்றே உங்கள் மின்வணிக வணிகத்தை நிர்வகிக்கத் தொடங்குங்கள்",
    invalidCredentials: "தவறான மின்னஞ்சல் அல்லது கடவுச்சொல்",
    accountCreated: "கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது!",
    loginToConnect: "தொடர தயவுசெய்து உள்நுழையுங்கள்.",
    passwordMinLength: "கடவுச்சொல் குறைந்தது 6 எழுத்துகளாக இருக்க வேண்டும்",
    passwordsDoNotMatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
    validEmailRequired: "தயவுசெய்து சரியான மின்னஞ்சலை உள்ளிடுங்கள்",
    nameRequired: "பெயர் தேவை",
    loginSuccessful: "வெற்றிகரமான உள்நுழைவு",
    signupSuccessful: "வெற்றிகரமான பதிவு",
}